import { Link } from 'react-router-dom';

const LAST_UPDATED = '26 de marzo de 2026';

export default function Terminos() {
  return (
    <div className="min-h-screen bg-white">
      <div className="bg-slate-50 border-b border-gray-200 py-12">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 text-sm font-semibold mb-6 cursor-pointer">
            <i className="ri-arrow-left-line" />
            Volver al inicio
          </Link>
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">Términos y Condiciones</h1>
          <p className="text-gray-400 text-sm">Última actualización: {LAST_UPDATED}</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-14">
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 mb-10">
          <p className="text-amber-800 text-sm leading-relaxed">
            <strong>Importante:</strong> Al usar RemesasVE, aceptas estos términos. Si no estás de acuerdo, por favor no uses nuestro sitio.
          </p>
        </div>

        <div className="flex flex-col gap-10 text-sm text-gray-600 leading-relaxed">

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">1. Descripción del Servicio</h2>
            <p>
              RemesasVE (<em>remesasve.com</em>) es una plataforma de comparación de servicios de remesas. Recopilamos y presentamos información pública sobre tasas de cambio, comisiones y características de servicios de transferencia de dinero para ayudar a los usuarios a tomar decisiones informadas.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">2. No Procesamos Transferencias</h2>
            <p className="mb-3">
              RemesasVE <strong>no es un servicio de transferencia de dinero</strong>. No procesamos pagos, no manejamos fondos de usuarios y no somos responsables de las transacciones realizadas a través de los servicios de terceros que enlazamos.
            </p>
            <p>
              Cuando haces clic en un botón de acción, serás redirigido al sitio web del proveedor correspondiente. Las transacciones son entre tú y dicho proveedor.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">3. Exactitud de la Información</h2>
            <p className="mb-3">
              Actualizamos la información de tasas y comisiones diariamente, sin embargo, <strong>no garantizamos la exactitud, integridad o vigencia de los datos mostrados</strong>. Las tasas de cambio son dinámicas y pueden variar en cualquier momento.
            </p>
            <p>
              Siempre verifica la información directamente en el sitio del proveedor antes de realizar cualquier transferencia. RemesasVE no se responsabiliza por diferencias entre los datos mostrados y los aplicados por los proveedores.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">4. Sin Asesoramiento Financiero</h2>
            <p>
              El contenido de RemesasVE es estrictamente informativo y de comparación. <strong>No constituye asesoramiento financiero, legal ni fiscal.</strong> Para decisiones financieras importantes, consulta con un profesional calificado.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">5. Relaciones de Afiliado</h2>
            <p>
              RemesasVE puede tener relaciones de afiliado con algunos de los servicios comparados. Esto significa que podemos recibir una comisión si completas una transacción a través de nuestros enlaces de referido. Esta compensación no influye en la objetividad de nuestras comparaciones y no tiene ningún costo adicional para ti.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">6. Propiedad Intelectual</h2>
            <p>
              Todo el contenido de RemesasVE (textos, diseño, logotipos propios, código) es propiedad de RemesasVE o sus creadores y está protegido por las leyes de propiedad intelectual aplicables. Los logotipos de terceros (Wise, Remitly, etc.) pertenecen a sus respectivos propietarios.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">7. Limitación de Responsabilidad</h2>
            <p>
              En la máxima medida permitida por la ley, RemesasVE no será responsable por daños directos, indirectos, incidentales o consecuentes derivados del uso del sitio o de la información proporcionada en él.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">8. Modificaciones</h2>
            <p>
              Nos reservamos el derecho de modificar estos Términos en cualquier momento. Los cambios entrarán en vigencia al momento de su publicación en esta página. El uso continuado del sitio tras dichos cambios implica su aceptación.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">9. Ley Aplicable</h2>
            <p>
              Estos Términos se rigen por las leyes aplicables sin considerar conflictos de normas. Cualquier disputa será resuelta de buena fe entre las partes.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-bold text-gray-900 mb-3">10. Contacto</h2>
            <p>
              Para preguntas sobre estos Términos, contáctanos en:{' '}
              <a href="mailto:info@remesasve.com" className="text-green-600 font-semibold">info@remesasve.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
